const API_ENDPOINT = 'https://app.stosh.au/api/v1/store-front/locations';

async function fetchStoresData() {
  const response = await fetch(API_ENDPOINT, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }

  const json = await response.json();
  return json.data || [];
}

function showLoadingState(storeListEl) {
  storeListEl.innerHTML = `
    <div class="stosh-store-locator__loading">
      <div class="stosh-store-locator__spinner"></div>
    </div>
  `;
}

function groupByState(stores) {
  const grouped = {};

  stores.forEach(store => {
    if (!store.url) return; // skip stores with no page to link to

    const state = store.state || 'Other Locations';
    if (!grouped[state]) grouped[state] = [];
    grouped[state].push(store);
  });

  return grouped;
}

function renderStores(storeListEl, stores) {
  storeListEl.innerHTML = ''; // clear spinner

  const grouped = groupByState(stores);
  const OTHER = 'Other Locations';

  Object.keys(grouped)
    .sort((a, b) => {
      if (a === OTHER) return 1;
      if (b === OTHER) return -1;
      return a.localeCompare(b);
    })
    .forEach(state => {
      const stateSection = document.createElement('div');
      stateSection.classList.add('stosh-store-locator__state-section');

      const stateHeading = document.createElement('h2');
      stateHeading.textContent = state;
      stateSection.appendChild(stateHeading);

      const ul = document.createElement('ul');
      ul.classList.add('stosh-store-locator__list');

      grouped[state]
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach(store => {
          const li = document.createElement('li');
          const a = document.createElement('a');

          a.href = store.url;
          a.textContent = store.name + ' ';

          if (store.is_new) {
            const newLabel = document.createElement('span');
            newLabel.classList.add('stosh-store-locator__new-label');
            newLabel.textContent = 'NEW';
            a.appendChild(newLabel);
          }

          li.appendChild(a);
          ul.appendChild(li);
        });

      stateSection.appendChild(ul);
      storeListEl.appendChild(stateSection);
    });
}

async function initList() {
  const storeListEl = document.getElementById('stosh-store-list');
  if (!storeListEl) return;

  showLoadingState(storeListEl);

  try {
    const stores = await fetchStoresData();
    renderStores(storeListEl, stores);
  } catch (err) {
    console.error('Failed to load store list:', err);
    storeListEl.innerHTML = '<p>Unable to load store locations right now.</p>';
  }
}

document.addEventListener('DOMContentLoaded', initList);
document.addEventListener("shopify:section:load", initList);